// @ts-nocheck

import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { navigate } from '../../../lib/helpers';
import Button from 'antd/lib/button';

import { Header, Section } from './../../../components/layout';
import { Tabs, TabItem } from './../../../components/ui';
import ArchiveTripList from './ArchiveTripList';
import IncomeTripList from './IncomeTripList';
import { RouteComponent } from '../../../lib/routerAdapter';

export default () => {
  const location = useLocation();

  return (
    <>
      <Header left={<h1>Путевые листы собственных ТС</h1>} />
      <Tabs
        withRouter
        rightElement={
        (location.pathname === '/trips/self' ||
        location.pathname === '/trips/self/') &&
        <Button
          type="primary"
          style={{ marginRight: '20px' }}
          onClick={() => navigate('/trips/self/new')}>

              Создать
            </Button>

        }>

        <TabItem label="Входящие" url="/trips/self" />
        <TabItem label="Архив" url="/trips/self/archive" />
      </Tabs>
      <Section>
        <Routes>
          <Route index element={<RouteComponent component={IncomeTripList} />} />
          <Route path="archive" element={<RouteComponent component={ArchiveTripList} />} />
        </Routes>
      </Section>
    </>);

};